module.exports = __webpack_public_path__ + "img/modal-document-null.8bb8c751.svg";